import { ContributorGroupType } from '@/features/contributorGroups/constants'
import {
  ApprovalStatus,
  ContributorStatus,
  OfferBookingDocumentTypes,
  OfferDocumentTypes,
  OfferExternalDocumentTypes,
  OfferInternalDocumentTypes,
  OfferSourcingDocumentTypes,
  OfferStatus,
  OfferTenderDocumentTypes,
  RoleInOffer,
  OfferStage,
} from '@/features/offers/constants'
import { isNullish } from '@/utils/helper'
import { OfferBookingStatus } from '@eapproval/offer-shared'

export const getTotalEuroLiability = (liabilityCapType, totalLiabilityCapValue, totalPrice, euroExchangeRate = 8.9) => {
  if (typeof euroExchangeRate !== 'number' || isNaN(euroExchangeRate) || euroExchangeRate === 0) {
    return 0
  }
  if (typeof totalPrice !== 'number' || isNaN(totalPrice) || totalPrice === 0) {
    return 0
  }
  const percentage = parseFloat(totalLiabilityCapValue) || 0

  switch (liabilityCapType) {
    case 'limitedPercentage':
      return (percentage * totalPrice) / 100 / euroExchangeRate
    case 'limited':
      return totalLiabilityCapValue / euroExchangeRate
    default:
      return 0
  }
}

export const isContributor = (role) => {
  return [
    RoleInOffer.COMMERCIAL_PROJECT_MANAGER,
    RoleInOffer.TECHNICAL_PROJECT_MANAGER,
    RoleInOffer.CONTRIBUTOR_LEGAL,
    RoleInOffer.CONTRIBUTOR_QS,
    RoleInOffer.CONTRIBUTOR_OTHER,
  ].includes(role)
}

export const getStage = (status) => {
  if (Object.values(OfferBookingStatus).includes(status)) {
    return OfferStage.BOOKING
  }

  return OfferStage.QUOTATION
}
